import { TextField } from "@flat-ui";
import { AnalyticsFeedbackOptionList } from "@components/analytics/in-house/feedback/analytics-feedback-option-list";
import { AnalyticsFeedbackStepLayout } from "@components/analytics/in-house/feedback/analytics-feedback-step";
import {
  FeedbackStepDefinition,
  FeedbackStepProps,
  SurveyAnswers,
} from "@components/analytics/in-house/feedback/analytics-feedback-types";
import {
  DECISIONS_OPTIONS,
  OTHER_VALUE,
} from "@components/analytics/in-house/feedback/analytics-feedback-helper";

/**
 * Requires at least one selection, and a non-empty free-text answer when the
 * "Something else…" option is selected.
 */
function isValid(answers: SurveyAnswers): boolean {
  if (answers.decisions.length === 0) {
    return false;
  }
  const hasOtherSelected = answers.decisions.includes(OTHER_VALUE);
  return !hasOtherSelected || answers.decisionOther.trim().length > 0;
}

/** Multi-select "what are you trying to decide" step with a required "other" field. */
function AnalyticsFeedbackStep1Content({
  answers,
  onAnswersChange,
}: FeedbackStepProps): JSX.Element {
  const shouldShowOther = answers.decisions.includes(OTHER_VALUE);

  function toggleDecision(value: string): void {
    const decisions = answers.decisions.includes(value)
      ? answers.decisions.filter((current) => current !== value)
      : [...answers.decisions, value];
    onAnswersChange({ decisions });
  }

  return (
    <AnalyticsFeedbackStepLayout
      title="When you open analytics, what are you usually trying to decide?"
      subtext="Select all that apply."
    >
      <AnalyticsFeedbackOptionList
        options={DECISIONS_OPTIONS}
        selectedValues={answers.decisions}
        isMultiSelect
        onToggle={toggleDecision}
      />
      {shouldShowOther && (
        <TextField
          fullWidth
          placeholder="Tell us…"
          text={answers.decisionOther}
          onTextChanged={(decisionOther) => onAnswersChange({ decisionOther })}
        />
      )}
    </AnalyticsFeedbackStepLayout>
  );
}

/** Step definition registered in the survey flow. */
export const analyticsFeedbackStep1: FeedbackStepDefinition = {
  stepName: "decisions",
  StepComponent: AnalyticsFeedbackStep1Content,
  isValid,
};
